<template>
  <div v-if="scrolled" class="ScrollToTopButton cursor-pointer" @click="goToTop">
    <ScrollToTopIcon class=""></ScrollToTopIcon>
  </div>
</template>

<script>
import ScrollToTopIcon from '@/assets/icons/ScrollToTopIcon'
export default {
  name: 'ScrollToTopButton',
  components: { ScrollToTopIcon },
  data() {
    return {
      scrolled: false
    }
  },
  mounted() {
    this.scrollChecker()
    window.addEventListener('scroll', this.scrollChecker)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollChecker)
  },
  methods: {
    goToTop() {
      window.scrollTo(0, 0)
    },
    scrollChecker() {
      this.scrolled = window.scrollY > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.ScrollToTopButton {
  // Outlined/light treatment (see ScrollToTopIcon) so the control reads as page navigation
  // and not as part of the composer's controls - it used to match the Send button's solid
  // navy circle exactly - #1684 QA.
  @apply fixed rounded-full shadow-dropdown;
  // Sits in the bottom-right corner with the same gap on the right and at the bottom, and
  // stays above the page UI so it is never hidden behind a composer or a floating bar
  // (modals/tooltips live at z-index 10000, above this) - #1684 QA.
  right: 2.25rem;
  bottom: 2.25rem;
  width: 2.75rem;
  height: 2.75rem;
  z-index: 1000;
  @screen mob {
    right: 1rem;
    bottom: 1rem;
  }
}
</style>
